import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ShepStep from './shapeStep/shapeStep';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    desc: {
        textAlign: 'justify',
        margin: 0,
        padding: 0,
        border: 0,
        font: "inherit",
        verticalAlign: "baseline",
        color: 'rgb(66, 71, 77)',
        lineHeight: 3,
        '& a': {
            color: 'blue !important',
            padding: '0px 5px'
        }
    },
    title: {
        marginTop: 30,
        fontSize: 20,
        fontWeight: "bold",
        marginBottom: 10,
    },
    gridStep: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: 750,
        margin: 'auto',
        marginTop: 30,
        '@media (max-width: 860px)': {
            width: '100%',
            flexDirection: 'column-reverse',
            justifyContent: 'center',
            alignItems: 'center',
        },
    },
    list: {
        '@media (max-width: 500px)': {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    cardStep: {
        '@media (max-width: 860px)': {
            width: 500,
            maxWidth: '98%'
        },
    }
}));

export default function Index() {

    const classes = useStyles()

    let data = [
        {
            colors: {
                circle: 'rgba(246,246,246)',
                rectangle: 'rgba(165,165,165)'
            },
            data: {
                step: '',
                title: 'بررسی سهام',
                list: [
                    `دقت کنید سهام عدالت به دوروش می باشد : 1- مستقیم 2- غیر مستقیم`,
                    `اگر روش انتخابی سهام عدالت تغییر نکرده باشد، درواقع روش، غیر مستقیم است، کافی است پس از دریافت نام کاربری و رمز عبورسامانه آنلاین کارگزاری، به آدرس زیر مراجعه کنید `,
                    `پس از ورود به سامانه آنلاین گزینه تغییرکارگزار ناظر را انتخاب نموده سپس نام نماد سرمایه گذاری استان خود را انتخاب کنید.`,
                    `مثلا نماد تهران با نام وستهران`,
                    `اصفهان با نام وسصفا`,
                    `و یا با وارد کردن نام استان خود، نماد مورد نظر را پیدا کنید. `,
                    `روز کاری بعد نماد مدنظر به سبد سهام شما یا اصطلاحاً پرتفوی شما اضافه خواهد شد.`,
                    `ولی اگر روش سهام عدالت را تغییر داده اید، یعنی روش مستقیم را انتخاب کرده باشید می توانید ریز دارایی خود را در درگاه یکپارچه ذینفعان بازار سرمایه، قسمت «دارایی ها» مشاهده کنید. `,
                ]
            },
            visibaleRectangle: true
        },
        {
            colors: {
                circle: 'rgba(247,240,230)',
                rectangle: 'rgba(173,99,0)'
            },
            data: {
                step: 'مرحله دوم',
                title: 'ثبت نام در کارگزاری',
                list: [
                    `ابتدا در کارگزاری پویان ثبت نام نمایید، که بصورت غیرحضوری و رایگان انجام می شود.`,
                    `در صورت تمایل به ثبت نام غیر حضوری می توانید به آدرس زیر مراجعه نمایید و حداکثر 24 ساعت کاری پس از گذراندن تمام مراحل ثبت نام، نام کاربری و رمز سامانه معاملاتی برای شما ارسال می شود.`,
                ]
            },
        },
        {
            colors: {
                circle: 'rgba(248,235,230)',
                rectangle: 'rgba(180,53,0)'
            },
            data: {
                step: 'مرحله اول',
                title: 'سجام',
                list: [
                    ` سهامداران محترم باید در سایت سجام ثبت نام نموده و کد 10 رقمی را دریافت نمایند و اگر پیش از این برای ثبت نام در سجام اقدام نموده اید از این مرحله صرف نظر کنید.
                        ثبت نام سجامwww.sejam.ir`,
                    `برای احراز هویت سجام خود می توانید از لینک زیر اقدام نمایید:`,
                    `احراز هویت:ehraz.pouyanbroker.ir`,
                ]
            },
        }
    ]

    return (
        <div className={classes['root']}>
            <div>
                <h3 className={classes['title']}>
                    مراحل کلی انتقال سهام عدالت متوفیان
                </h3>
            </div>
            <div>
                <p className={classes['desc']}>
                    سهامداران سهام عدالت و وارثین محترم برای مشاهده دارایی خود در کارگزاری باید مراحل زیر را طی نمایند :
                </p>
                <p className={classes['desc']}>
                    پس از اتمام مراحل تقسیم سهام عدالت وراث و تایید آن توسط سپرده گذاری مرکزی، سهام عدالت به دارایی شما اضافه خواهد شد.
                </p>
                <p className={classes['desc']}>
                    دقت کنید در حال حاضر امکان خرید یا فروش سهام عدالت وجود ندارد ولی برای بررسی و یا معامله این سهام در زمان بازگشایی در هر صورت باید مراحل اعلامی قبل را انجام دهید.
                </p>
            </div>
            <div className={classes['gridStep']}>
                {
                    data?.map((item, index) => {
                        return (
                            <ShepStep
                                key={index}
                                item={item}
                                className={classes['cardStep']}
                            />
                        )
                    })
                }
            </div>
        </div>
    );
}

